<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 财务中心->在线充值 -->
    <div class="main2">
      <div class="title">余额充值</div>
      <div class="main2" v-if="isOpenPay > 0">
        <div class="info">
          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-form-item label="充值金额" prop="payAmount">
              <el-input
                v-model="form.payAmount"
                onkeyup="value=value.replace(/[^0-9.]/g,'')"
                placeholder="请输入充值金额"
              />
            </el-form-item>
            <el-form-item label="支付方式" prop="paymentMethodId">
              <el-select
                v-model="form.paymentMethodId"
                placeholder="请选择支付方式"
                style="width:100%;"
              >
                <el-option
                  v-for="(item) of paymentMethodList"
                  :key="item.paymentMethodId"
                  :label="item.paymentMethodName"
                  :value="item.paymentMethodId"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button
                style="border-color:#97c5e9;margin-top:20px;border-radius:0;"
                @click="submitBefore"
                >确认充值</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="main borderShadow" v-if="isOpenPay == 0">
        <span>{{ openTip }}</span>
      </div>
    </div>
    <!-- 财务中心->在线充值 -->

    <!-- 微信支付二维码 -->
    <div class="wechat flexStyle1" v-if="wechatshow">
      <div class="main">
        <div class="tips" v-if="paySuccessShow">
          成功支付金额 <span>{{ form.payAmount }}</span> 元
          <span @click="closePay" class="hands c-animation2">确认</span>
        </div>
        <div class="tips" v-if="!paySuccessShow">
          支付金额 <span>{{ form.payAmount }}</span> 元
        </div>
        <div class="text">微信收款码</div>
        <div @click="closePay" class="close hands c-animation3">关闭</div>
      </div>
    </div>
    <div id="wechatcode" class="wechatcode"></div>
    <!-- 微信支付二维码 -->

    <!-- 支付宝支付 -->
    <div class="wechat flexStyle1" v-if="alipayshow">
      <div class="main main2">
        <div class="text" v-if="!paySuccessShow">支付宝付款中...</div>
        <div class="tips tips2" v-else>
          成功支付金额 <span>{{ from.payAmount }}</span> 元
          <span @click="closePay" class="hands c-animation2">确认</span>
        </div>
        <div @click="closePay" class="close hands c-animation3">关闭</div>
      </div>
    </div>
    <!-- 支付宝支付 -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import { payStatusRequest, submitPayRequest } from "../../../public/js/service";
import QRCode from "qrcodejs2";

export default {
  data() {
    const maxCheck = (rule, value, callback) => {
      if (parseFloat(value) > rule.max) {
        callback(new Error(rule.message));
      } else {
        callback();
      }
    };
    // 1.data
    return {
      paymentMethodList: [],
      isOpenPay: 0,
      openTip: "",
      paymentMethodId: null, // 1.1.支付方式id(1:支付宝;2:微信)
      payAmount: "", // 1.2.充值金额
      returnUrl: "", // 1.3.支付成功跳转地址
      ip: "", // 1.4.请求ip
      bathId: "", // 1.5.代发结算批次id,余额支付时必传。
      wechatshow: false,
      alipayshow: false,
      payNum: "", // 1.6.支付单据号，用于查询当前支付状态
      payNumTimer: null, // 1.7.轮训timer
      paySuccessShow: false,
      form: {
        paymentMethodId: null,
        payAmount: null,
      },
      rules: {
        payAmount: [
          { required: true, message: "充值金额不能为空", trigger: "change" },
          {
            message: "金额只能是两小数",
            trigger: "change",
            pattern: /(^[\d]|^[1-9][\d]*)($|[\\.][\d]{0,2}$)/,
          },
          {
            message: "单笔金额不能超过50000.00",
            max: 50000.0,
            validator: maxCheck,
            trigger: "change",
          },
        ],
        paymentMethodId: [
          { required: true, message: "支付方式不能为空", trigger: "blur" },
        ],
      },
    };
  },

  components: {
    // 2.components
  },

  methods: {
    // 3.methods
    submitBefore() {
      // 3.1.确认支付之前
      if (!this.form.payAmount || this.form.payAmount <= 0) {
        // 校验充值金额
        this.$notify({
          title: "提示",
          message: "请输入正确充值金额",
        });
        return;
      }

      this.submit();
    },

    submit() {
      // 3.2.确认充值请求
      this.openLoading();

      let data = {
        paymentMethodId: this.form.paymentMethodId,
        payAmount: this.form.payAmount,
        returnUrl: this.returnUrl,
        ip: this.ip,
        bathId: this.bathId,
      };

      submitPayRequest(data).then((res) => {
        this.closeLoading();
        if (res) {
          if (this.form.paymentMethodId == 1) {
            this.alipay(res);
          } else if (this.form.paymentMethodId == 2) {
            this.wechatpay(res);
          }
        }
      });
    },

    alipay(res) {
      // 3.4.支付宝支付
      this.payNum = res.data.payNum;
      this.alipayshow = true;
      this.watchPayStatus();

      let divForm = document.getElementsByTagName("divform");

      if (divForm.length) {
        document.body.removeChild(divForm[0]);
      }

      const div = document.createElement("divform");
      div.innerHTML = res.data.payCode;
      document.body.appendChild(div);
      document.forms[0].setAttribute("target", "_blank");
      document.forms[0].submit();
    },

    wechatpay(res) {
      // 3.5.微信支付
      this.payNum = res.data.payNum;

      new QRCode("wechatcode", {
        width: 200,
        height: 200,
        text: res.data.payCode,
        colorDark: "#000",
        colorLight: "#fff",
      });

      this.wechatshow = true;
      this.watchPayStatus();
    },

    closePay() {
      // 3.6.关闭支付
      clearInterval(this.payNumTimer);
      this.paySuccessShow = false;
      this.wechatshow = false;
      this.alipayshow = false;
      localStorage.removeItem("userInfo");
      this.$router.push("/financeCenter?tt=" + Math.random());
    },

    watchPayStatus() {
      // 3.7.根据支付单据编号查询单据状态
      this.payNumTimer = setInterval(() => {
        this.payStauts();
      }, 3000);
    },

    payStauts() {
      // 3.8.状态查询
      let data = {
        payNum: this.payNum,
      };

      payStatusRequest(data).then((res) => {
        if (res) {
          if (res.data.status == 0) {
            // 3.8.1.支付状态为成功
            clearInterval(this.payNumTimer);
            this.paySuccessShow = true;
          }
        }
      });
    },

    openLoading() {
      // 3.9.打开加载遮罩层
      this.loadingInstance = this.$loading.service({
        fullscreen: true,
        lock: true,
      });
    },

    closeLoading() {
      // 3.10.关闭遮罩层
      this.loadingInstance.close();
    },
  },

  mounted() {
    this.returnUrl =
      window.location.protocol +
      "//" +
      window.location.hostname +
      "/#/financeCenter?buttonsIndex=4";

    this.ip = localStorage.getItem("Ip");
    if (localStorage.baseInfo) {
      let obj = JSON.parse(localStorage.baseInfo);
      if (obj.web_pay_type) {
        this.paymentMethodList = obj.web_pay_type;
        this.isOpenPay = this.paymentMethodList.length;
        if (this.isOpenPay > 0) {
          this.openTip = obj.web_pay_tip || "";
          this.form.paymentMethodId = this.paymentMethodList[0].paymentMethodId;
        } else {
          this.openTip = obj.web_pay_tip || "";
          if (this.openTip == "") {
            this.openTip = "商家未开通在线支付，请线下支付！";
          }
        }
      }
    }
  },

  destroyed() {
    clearInterval(this.payNumTimer);
  },

  watch: {
    // watch
    payAmount() {
      if (this.form.payAmount < 0) {
        this.form.payAmount = 0;
      }
    },
  },
};
</script>

<style scoped lang="scss">
$ui-width: 1350px;
@function px2vw($px) {
  @return $px / $ui-width * 100vw;
}

$mainColor1: #e65a5a;
$mainColor2: #dd3242;
$mainColor3: #ff0000;

/* 1.all-container-style-start */
.all-container {
  border-radius: px2vw(6px);
  overflow: hidden;
  box-sizing: border-box;
  padding: px2vw(2px);
  width: 100%;

  > .main {
    flex: 1;
    border-radius: px2vw(6px);
    overflow: hidden;
    box-sizing: border-box;
    padding: px2vw(2px);

    > div {
      border-radius: px2vw(6px);
      overflow: hidden;
      margin-bottom: px2vw(20px);
      overflow: hidden;
      width: 100%;
      box-sizing: border-box;
      padding: px2vw(10px) px2vw(20px);
    }

    > .title {
      font-size: 15px;
      color: #999;
      font-weight: bold;
    }

    > .main {
      padding-bottom: px2vw(20px);

      > .info {
        font-size: 14px;

        > .item {
          margin-bottom: px2vw(20px);

          > .top {
            margin-bottom: px2vw(10px);
            font-weight: bold;

            > span {
              color: $mainColor3;
              padding-right: px2vw(4px);
            }
          }

          > .bottom {
            width: px2vw(500px);
            max-width: 500px;
            height: px2vw(32px);
            max-height: 40px;
            border: 1px solid #ddd;
            border-radius: px2vw(4px);
            overflow: hidden;
            box-sizing: border-box;
            padding-left: px2vw(10px);
          }
        }
      }

      > .buttons {
        padding-top: px2vw(40px);

        > .item {
          background-color: $mainColor1;
          color: #fff;
          border-radius: 6px;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 px2vw(14px) px2vw(10px) 0;
          padding: 10px 80px;
        }
      }
    }
  }

  > .wechatcode {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -65%);
    z-index: 11;
  }

  > .wechat {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 9;
    background-color: rgba($color: #000000, $alpha: 0.5);

    > .main {
      width: 400px;
      height: 400px;
      border-radius: 7px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      box-sizing: border-box;
      padding-bottom: 30px;
      position: relative;

      > .close {
        position: absolute;
        top: 14px;
        right: 14px;
        z-index: 10;
        font-size: 14px;
        color: #999;
      }

      > .text {
        > span {
          color: #f00;
        }
      }

      > .tips {
        font-size: 20px;
        padding-bottom: 20px;
        color: #333;

        > span {
          color: red;
          font-size: 24px;

          &:nth-child(2) {
            font-size: 18px;
            display: inline-block;
            background-color: $mainColor1;
            color: #fff;
            border-radius: 4px;
            padding: 4px 18px;
            margin-left: 10px;
          }
        }
      }

      > .tips2 {
        padding-top: 10px;
        padding-bottom: 0px;
      }
    }

    > .main2 {
      padding-bottom: 80px;
      height: 200px;
      font-size: 17px;
    }
  }
}
/* 1.all-container-style-start */
</style>
